import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
//import MqttConnection from './components/MqttConnection';
//import registerServiceWorker from './registerServiceWorker';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import "./color.css";
render(
  <Provider store={store}>
    {/* <MqttConnection> */}
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App />
    </BrowserRouter>


    {/* </MqttConnection> */}
  </Provider>,
  document.getElementById('root'),
);

//registerServiceWorker();
